////////GHG EF 2.4 Schema
const twoFourSchema = {
  title: "2.4 Indirect Emissions from Purchased/Acquired Cooling",
  cat: "2_2",
  catName: "cat2",
  progressiveOrderSwitch: {
    by: { level: 2, key: "computationMethod" }, // 觀察誰
  },
  fields: [
    {
      key: "title",
      type: "title",
      title: "Emission Factor",
    },
    ////////Data Source (emissionFactorTypeId)
    {
      key: "emissionFactorTypeId",
      level: 1,
      type: "select",
      label: "Data Source",
      optionsAPI: "emissionFactorDropdown",
      autoFillNum: 0,
    },
    ////////Method of Calculation
    {
      key: "computationMethod",
      level: 2,
      type: "select",
      label: "Method of Calculation",
      optionsAPI: "emissionLevel",
      showIf: {
        level: 1,
        key: "emissionFactorTypeId",
        ne: "2",
      },
      combineKey: 1,
    },
    ////////Emission Factor Database Source (sourceEFName)
    {
      key: "sourceEFName",
      level: 3,
      type: "select",
      label: "Emission Factor Database Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 2,
        key: "computationMethod",
      },
      showIf: {
        level: 2,
        key: "computationMethod",
        notEmpty: true,
      },
      combineKey: 2,
    },
    //////// Fuel Type (emissionLevel) [Method of Calculation = Fuel Based]
    {
      key: "fuelType2_2",
      level: 4,
      type: "select",
      label: "Fuel Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 3,
        key: "sourceEFName",
      },
      showIf: {
        all: [
          { level: 2, key: "computationMethod", ne: "Energy Based" },
          { level: 3, key: "sourceEFName", notEmpty: true },
        ],
      },
      combineKey: 3,
    },
    //////// Fuel Name (emissionFactorId) [Method of Calculation = Fuel Based]
    {
      key: "emissionFactorId",
      level: 5,
      type: "select",
      label: "Fuel Name",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 4,
        key: "fuelType2_2",
      },
      showIf: {
        all: [
          { level: 2, key: "computationMethod", ne: "Energy Based" },
          { level: 4, key: "fuelType2_2", notEmpty: true },
        ],
      },
      combineKey: 4,
    },
    //////// Energy Type
    {
      key: "emissionFactorId",
      level: 5,
      type: "select",
      label: "Energy Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 3,
        key: "sourceEFName",
      },
      showIf: {
        all: [
          { level: 2, key: "computationMethod", ne: "Fuel Based" },
          { level: 3, key: "sourceEFName", notEmpty: true },
        ],
      },
      combineKey: 3,
    },
    ////////Emission Factor Name (自定義)
    {
      key: "emissionFactorId",
      addBtn: true,
      level: 5,
      type: "select",
      custom: true,
      label: "Emission Factor Name",
      optionsAPI: "cat1CustomEFDropdownList",
      showIf: {
        level: 1,
        key: "emissionFactorTypeId",
        eq: "2",
      },
      autoFillNum: 0,
    },
  ],
};

export default twoFourSchema;
